"use client";

import { ServiceBlocks } from "@/components/shared/public";
import { useTranslations } from "next-intl";

const ServiceBlockSteps = () => {
  const t = useTranslations("threeSixtyTour.serviceBlocks");

  const serviceBlocks = [
    {
      step: "01",
      title: t("title1"),
      text: t("text1"),
    },
    {
      step: "02",
      title: t("title2"),
      text: t("text2"),
    },
    {
      step: "03",
      title: t("title3"),
      text: t("text3"),
    },
    {
      step: "04",
      title: t("title4"),
      text: t("text4"),
    },
    {
      step: "05",
      title: t("title5"),
      text: t("text5"),
    },
    {
      step: "06",
      title: t("title6"),
      text: t("text6"),
    },
  ];

  return <ServiceBlocks id="section-2" serviceBlocks={serviceBlocks} />;
};

export default ServiceBlockSteps;
